import { FullWidthBannerColorPalette } from '../interfaces/fullWidthBanner';
import { BannerData } from '../interfaces/templatedFullWidthBanner';

export const DEFAULT_BANNER_DATA: BannerData = {
  color: FullWidthBannerColorPalette.INFO,
  message: '',
  canClose: true,
  thumbnailName: 'error-filled'
};
